import { Component, OnInit } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';

@Component({
  selector: 'ngx-ofbiz-cell-input',
  template: `<input fieldSize="tiny" nbInput [(ngModel)]="value"/>`,
  styleUrls: ['./ofbiz-cell-input.component.scss']
})
export class OfbizCellInputComponent implements ViewCell, OnInit{
  
  value: string | number;
  rowData: any;
  editable:boolean;
  baseUrl:string;
  field:any;




  ngOnInit(): void {
    //throw new Error('Method not implemented.');
  }

}
